import lowerCase from 'lodash/lowerCase'
import startCase from 'lodash/startCase'

import {ApiRequestStates} from '../const'
import {reducer} from './helpers'

import * as addressValidationActions from '../actions/addressValidation'
import {renameKeys} from '../utils'

const initialState = {
  inputAddress: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
  },
  isContinentalUs: true,
  isValid: false,
  recommendedUpdates: {},
  status: ApiRequestStates.IDLE,
}

export default reducer(initialState, (state, {payload, type}) => {
  switch (type) {
    case addressValidationActions.VALIDATE_ADDRESS:
      return {
        ...state,
        inputAddress: {...payload},
        isContinentalUs: true,
        isValid: false,
        recommendedUpdates: {},
      }
    case addressValidationActions.VALIDATE_ADDRESS_PENDING:
      return {...state, status: ApiRequestStates.PENDING}
    case addressValidationActions.VALIDATE_ADDRESS_FAILURE:
      return {...state, status: ApiRequestStates.ERROR}
    case addressValidationActions.VALIDATE_ADDRESS_SUCCESS: {
      const updates = renameKeys(payload.recommendedUpdates, {
        line1: 'address1',
        line2: 'address2',
        region: 'state',
        postalCode: 'zip',
      })
      const fieldsToStartCase = ['address1', 'address2', 'city']
      fieldsToStartCase.forEach((field) => {
        if (updates[field]) {
          updates[field] = startCase(lowerCase(updates[field]))
        }
      })

      return {
        ...state,
        isContinentalUs: payload.isContinentalUs,
        isValid: payload.isValid,
        recommendedUpdates: {...updates},
        status: ApiRequestStates.SUCCESS,
      }
    }
    default:
      return null
  }
})
